// Radha — login screen.
// Posts to the gateway login endpoint via the auth layer; on success the shell
// mounts. This component only collects and forwards credentials to the server —
// it never stores them. The server issues the short-lived RS256 access token.
import React, { useState } from "react";

export default function Login({ onLogin }: { onLogin: (email: string, password: string) => Promise<unknown> }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit() {
    setError(null);
    setBusy(true);
    try {
      await onLogin(email, password);
    } catch (e: any) {
      setError(e?.message || "login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--surface-2)", fontFamily: "Inter, system-ui, sans-serif" }}>
      <div style={{ width: 360, background: "var(--surface)", border: "0.5px solid var(--border)", borderRadius: 16, padding: 28 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
          <div style={{ width: 30, height: 30, borderRadius: 9, background: "#6E44D4", display: "grid", placeItems: "center", fontFamily: "monospace", fontWeight: 600, color: "#fff" }}>र</div>
          <div><div style={{ fontWeight: 600, fontSize: 17 }}>Radha</div><div style={{ fontSize: 11, color: "var(--fg-muted)" }}>Revenue Nervous System</div></div>
        </div>

        <label style={{ fontSize: 12, color: "var(--fg-muted)" }}>Work email</label>
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" autoComplete="username"
          style={{ width: "100%", boxSizing: "border-box", marginTop: 5, marginBottom: 14, padding: "10px 12px", border: "0.5px solid var(--border)", borderRadius: 9, fontSize: 13 }} />

        <label style={{ fontSize: 12, color: "var(--fg-muted)" }}>Password</label>
        <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" autoComplete="current-password"
          onKeyDown={(e) => e.key === "Enter" && submit()}
          style={{ width: "100%", boxSizing: "border-box", marginTop: 5, marginBottom: 4, padding: "10px 12px", border: "0.5px solid var(--border)", borderRadius: 9, fontSize: 13 }} />

        {error && <div style={{ color: "#D63B2F", fontSize: 12, marginTop: 8 }}>{error}</div>}

        <button onClick={submit} disabled={busy || !email || !password}
          style={{ width: "100%", marginTop: 16, padding: "11px 0", background: busy ? "#7A8190" : "#1B54F8", color: "#fff", border: "none", borderRadius: 9, fontSize: 14, fontWeight: 500, cursor: busy ? "default" : "pointer" }}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </div>
    </div>
  );
}
